var _title, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInfoIconQuoteSvg = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon/Large/Info")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5475176,0 C24.1504773,0 31.0950352,6.94814815 31.0950352,15.5555556 C31.0950352,17.531359 30.484882,19.9050215 29.2645758,22.6765432 L31.1882162,27.2820681 C31.3377366,27.6400455 31.3833671,28.0329086 31.3198774,28.4156269 C31.1332781,29.5404551 30.0701561,30.3010399 28.9453279,30.1144406 L23.4637298,29.2050909 C20.3852851,30.475771 17.7465477,31.1111111 15.5475176,31.1111111 C6.94455785,31.1111111 -1.13686838e-13,24.162963 -1.13686838e-13,15.5555556 C-1.13686838e-13,6.94814815 6.94455785,0 15.5475176,0 Z M17.58933,13.2222222 L13.5,13.2222222 L13.5,23.5925926 L17.58933,23.5925926 L17.58933,13.2222222 Z M15.5645161,7 C14.4054895,7 13.5,7.94606888 13.5,9.07407407 C13.5,10.2384665 14.4417091,11.1481481 15.5645161,11.1481481 C16.6873231,11.1481481 17.6290323,10.2384665 17.6290323,9.07407407 C17.6290323,7.90968161 16.6873231,7 15.5645161,7 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography-1",
    transform: "translate(-627.000000, -820.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Large/Info",
    transform: "translate(627.000000, 820.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#0A2F64",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colour/BrightPurple",
    mask: "url(#mask-2)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoIconQuoteSvg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info_icon_quote_svg.e03c5ab1.svg";
export { ForwardRef as ReactComponent };